import { configureStore } from '@reduxjs/toolkit'
import screenCacheReducer from './screenCacheSlice';

export default configureStore({
  reducer: {
    screenCache: screenCacheReducer
  }
});